import type { BatchPageDetail, BatchRunView } from "@/types";

/**
 * The page with a polled run laid over it.
 *
 * While a run is going the page is not re-read — only the run is, every few
 * seconds (`getBatchRun`). Anything that reads the page, like the run log,
 * would otherwise sit at the progress the page had when the run started while
 * the bar above it moves. The run's own summary and cells are the newer copy
 * until the run ends and the page is read again.
 */
export function withLiveRun(page: BatchPageDetail, live: BatchRunView | null): BatchPageDetail {
  if (!live || live.page_id !== page.page_id) return page;
  const { cells, ...run } = live;
  const known = page.runs.some((r) => r.batch_run_id === run.batch_run_id);
  return {
    ...page,
    runs: known
      ? page.runs.map((r) => (r.batch_run_id === run.batch_run_id ? { ...r, ...run } : r))
      : [run, ...page.runs],
    cells: { ...page.cells, [run.batch_run_id]: cells },
  };
}
